// extracted by mini-css-extract-plugin
module.exports = {"links":"clinical-portal-3__LinksAndResourcesModal__links","linkIcon":"clinical-portal-3__LinksAndResourcesModal__linkIcon"};